if (!customElements.get('course-form')) {
  customElements.define('course-form', class CourseForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = document.querySelector('[data-drawer-atc]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
  
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } 

          document.querySelector('.c-booking-drawer').classList.remove('active');
          document.body.classList.remove('overflow-hidden');

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');

          const dateTimeWrapper = document.querySelector('[data-date-time-slot]')
          const confirmCalendarButton = document.querySelector('[data-confirm-calendar-button]')
          const atcButton = document.querySelector('[data-confirm-atc-button]')
          const step1 = document.querySelector('.step1')
          const suburb = document.querySelector('[data-suburb]')
          const defaultTimeSelectors = document.querySelectorAll('#timeSelection [type="radio"]')
          const calendarPickerButton = document.querySelector('[data-calendar-picker]')

          defaultTimeSelectors.forEach(radio => {
            radio.checked = false;
          });

          this.form.reset();
          dateTimeWrapper.textContent = 'Choose a time'
          confirmCalendarButton.setAttribute('disabled', true)
          atcButton.setAttribute('disabled', true)
          step1.classList.add('active')
          calendarPickerButton.setAttribute('disabled', true);
          
          if(suburb) {
            suburb.classList.add('is-hidden')
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
